var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('runtime-template-compiler',{key:_vm.update,style:(_vm.styleModel),attrs:{"template":_vm.wrappedTemplate}})}
var staticRenderFns = []

export { render, staticRenderFns }